const cityTranslations = {
    en: {
        Porto: "Oporto",
        Lisbon: "Lisbon",
        Aveiro: "Aveiro",
        Coimbra: "Coimbra",
        Braga: "Braga",
        Madrid: "Madrid",
        Barcelona: "Barcelona",
        Vigo: "Vigo",
        Rome: "Rome",
        Florence: "Florence",
        Milan: "Milan",
        Paris: "Paris",
        London: "London",
        Edinburgh: "Edinburgh",
        Dublin: "Dublin",
        Amsterdam: "Amsterdam",
        Brussels: "Brussels",
        Berlin: "Berlin",
        Munich: "Munich",
        "Rio de Janeiro": "Rio de Janeiro",
        Salvador: "Salvador",
        "São Paulo": "São Paulo"
    },
    pt: {
        Porto: "(o )Porto",
        Lisbon: "Lisboa",
        Aveiro: "Aveiro",
        Coimbra: "Coimbra",
        Braga: "Braga",
        Madrid: "Madrid",
        Barcelona: "Barcelona",
        Vigo: "Vigo",
        Rome: "Roma",
        Florence: "Florença",
        Milan: "Milão",
        Paris: "Paris",
        London: "Londres",
        Edinburgh: "Edimburgo",
        Dublin: "Dublin",
        Amsterdam: "Amsterdão",
        Brussels: "Bruxelas",
        Berlin: "Berlim",
        Munich: "Munique",
        "Rio de Janeiro": "(o )Rio de Janeiro",
        Salvador: "Salvador",
        "São Paulo": "São Paulo"
    },
  };
  
  export default cityTranslations;

  export const translateCity = (key, language) => {
    return cityTranslations[language]?.[key] || cityTranslations['en'][key] || key;
  };
  